export default {
  computed: {
    dataBar() {
      if (this.data.items) {
        return {
          labels: this.getLabels(),
          datasets:[
            {
              backgroundColor: this.getBackground(),
              hoverBackgroundColor: this.getBackground(),
              data: this.getDataSets(),
              showLabel: this.showLabel,
            }]
        };
      }

      return {};
    }
  },
  methods: {
    getBackground() {
      let entries = this.data.items.filter(it => it.thematic_id != 0 && it.count != 0) || [];
      let newEntries = entries.map(item => {
        if (Number(item.count) === 0) {
          return 0;
        }
        return '#' + parseInt(item.thematic_id*item.thematic_id*3, 16).toString(16)
      });
      newEntries.push('#5E6D82')
      return newEntries
    },
    getDataSets() {
      let entries = this.data.items.filter(it => it.thematic_id != 0 && it.count != 0) || [];
      let summ = entries.reduce(function(sum, elem) {
        return sum + Number(elem.count);
      }, 0);

      let dataSet = entries.map(item => {
        if (Number(item.count) === 0) {
          return 0;
        }
        return item.ratio;
      });
      if (this.data.items) dataSet.push(this.data.items.filter(it => it.thematic_id == 0)[0].ratio)
      return dataSet
    },
    getLabels() {
      const keys = Object.keys(this.data.items);
      let labels = this.data.items.filter(it => it.thematic_id != 0 && it.count != 0).map(item => {
        return item.title;
      }) || '';
      labels.push('Без тематики')
      return labels
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 9,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: (value) => {
              if (value === 0) {
                return "";
              }

              return value + '%';
            },
            anchor: "center",
            color: "#ffffff",
            font: {
              weight: "normal",
              size: 14,
              family: "Roboto"
            },
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
